// Translations for Kara Immobilier Service
export const translations = {
  fr: {
    // Navbar
    nav: {
      services: "Services",
      benefits: "Pourquoi nous choisir",
      about: "À propos",
      pricing: "Tarifs",
      contact: "Contact",
      cta: "Discuter avec un expert",
      ctaSecondary: "Confier mon bien"
    },
    // Hero
    hero: {
      subtitle: "Gestion & Location Immobilière",
      title: "Gestion Immobilière",
      titleAccent: "Sans Souci.",
      description: "Kara Immobilier Service transforme la gestion locative. Plus de revenus, moins de stress, une transparence totale.",
      tagline: "Plus de revenus. Moins de stress.",
      ctaPrimary: "Discuter avec un expert",
      ctaSecondary: "Confier mon bien",
      ctaTertiary: "Voir nos services",
      promises: [
        "Service professionnel",
        "Réponse rapide",
        "Gestion complète"
      ]
    },
    // Services
    services: {
      subtitle: "Nos Services",
      title: "Une Gestion Complète à 360°",
      description: "Confiez-nous la gestion de vos biens immobiliers et profitez d'une tranquillité d'esprit totale.",
      items: [
        {
          title: "Mise en Location",
          description: "Photos professionnelles, rédaction d'annonces, organisation des visites, enquête de crédit et vérification complète des locataires."
        },
        {
          title: "Gestion complète des locataires",
          description: "Appels, suivis, plaintes - nous gérons toutes les interactions avec vos locataires pour vous."
        },
        {
          title: "Encaissement des Loyers",
          description: "Collecte ponctuelle et sécurisée des loyers avec suivi en temps réel de vos revenus."
        },
        {
          title: "Gestion des Retards",
          description: "Relances professionnelles et gestion des impayés pour protéger vos revenus."
        },
        {
          title: "Coordination Réparations",
          description: "Réseau d'artisans qualifiés et coordination complète des travaux d'urgence et d'entretien."
        },
        {
          title: "Entretien & Maintenance",
          description: "Programmes de maintenance préventive pour préserver la valeur de vos biens."
        },
        {
          title: "Suivi et accompagnement continu",
          description: "Ligne directe avec vos locataires et rapports réguliers sur l'état de vos propriétés."
        }
      ]
    },
    // Benefits
    benefits: {
      subtitle: "Résultats",
      title: "Tranquillité d'Esprit Totale",
      speech: "Chez Kara Immobilier Service, notre objectif est de faciliter la gestion des biens immobiliers tout en aidant les propriétaires à gagner plus d'argent. Nous proposons un service complet: trouver des locataires, gérer les loyers et assurer l'entretien des logements. Nous mettons l'accent sur le sérieux, la disponibilité et le professionnalisme. Notre priorité est d'offrir une expérience simple et sécurisée à nos clients.",
      items: [
        {
          title: "Vous gagnez du temps",
          description: "Plus besoin de gérer les appels, les visites ou les urgences. Nous nous occupons de tout."
        },
        {
          title: "Vous évitez les problèmes",
          description: "Notre expertise vous protège des locataires difficiles et des situations complexes."
        },
        {
          title: "Vos revenus sont sécurisés",
          description: "Encaissement garanti, gestion des impayés et optimisation de votre rentabilité."
        }
      ],
      satisfaction: "Satisfaction garantie"
    },
    // About - Présentation Yakhara Hane
    about: {
      subtitle: "Fondatrice",
      title: "Yakhara Hane",
      role: "Gestionnaire immobilière & fondatrice de Kara Immobilier Service",
      badge: "Présentation Professionnelle",
      paragraphs: [
        "Titulaire d'un baccalauréat en administration des affaires, Yakhara Hane est une professionnelle déterminée, passionnée par la gestion immobilière et l'optimisation des investissements locatifs.",
        "Avec une approche rigoureuse, humaine et orientée résultats, elle accompagne les propriétaires dans la valorisation de leurs biens, en offrant des services complets allant de la location à la gestion quotidienne des immeubles.",
        "Son objectif est simple : offrir une gestion efficace, transparente et rentable, tout en garantissant la tranquillité d'esprit de ses clients.",
        "Grâce à son sens du détail, son professionnalisme et sa vision entrepreneuriale, Yakhara Hane positionne Kara Immobilier Service comme un partenaire de confiance dans le secteur immobilier."
      ],
      values: [
        { label: "Formation", value: "B.A.A — Administration des affaires" },
        { label: "Approche", value: "Rigoureuse, humaine, orientée résultats" },
        { label: "Vision", value: "Gestion efficace, transparente et rentable" }
      ]
    },
    // Pricing - Tarifs
    pricing: {
      subtitle: "Nos tarifs",
      title: "Tarifs – Kara Immobilier Service",
      description: "Des honoraires justes, alignés sur vos résultats, sans frais cachés.",
      plans: [
        {
          icon: "listing",
          name: "Mise en location",
          intro: "Nous vous accompagnons dans la recherche de locataires qualifiés avec un service complet comprenant :",
          features: [
            "Prise de photos professionnelles",
            "Diffusion des annonces",
            "Organisation des visites",
            "Enquête de crédit",
            "Vérification d'emploi et références"
          ],
          priceLabel: "Honoraires :",
          priceLines: [
            "100% du premier mois de loyer",
            "80% du premier mois de loyer dans le cadre d'un mandat de gestion locative"
          ]
        },
        {
          icon: "management",
          name: "Gestion locative",
          intro: "Nous veillons à une gestion complète de votre bien afin de vous offrir tranquillité et efficacité :",
          features: [
            "Gestion des locataires",
            "Suivi des loyers",
            "Gestion des plaintes",
            "Coordination des interventions",
            "Suivi administratif"
          ],
          priceLabel: "Honoraires :",
          priceLines: [
            "À partir de 7% du loyer mensuel par unité"
          ],
          featured: true
        },
        {
          icon: "maintenance",
          name: "Maintenance et services supplémentaires",
          intro: "Les services techniques et d'entretien sont facturés séparément :",
          features: [
            "Réparations et travaux à la charge du propriétaire",
            "Services de nettoyage sur demande",
            "Coordination des interventions possible (frais applicables)"
          ],
          priceLabel: "",
          priceLines: []
        },
        {
          icon: "info",
          name: "Informations complémentaires",
          intro: "Tarifs ajustables selon :",
          features: [
            "Le type d'immeuble",
            "Le nombre d'unités",
            "Les besoins spécifiques"
          ],
          priceLabel: "",
          priceLines: []
        }
      ],
      cta: "Obtenir un devis personnalisé"
    },
    // Contact
    contact: {
      subtitle: "Contact",
      title: "Parlons de Votre Projet",
      description: "Remplissez le formulaire ci-contre et un de nos experts vous recontactera dans les 24 heures pour discuter de vos besoins.",
      responseBadge: "Réponse en moins de 24h",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse",
      addressValue: "9008 2e Avenue, Montréal",
      areas: "Zones desservies",
      form: {
        name: "Nom complet",
        namePlaceholder: "Jean Dupont",
        email: "Email",
        emailPlaceholder: "jean@exemple.com",
        phone: "Téléphone",
        phonePlaceholder: "+1 438 123 4567",
        serviceType: "Type de service",
        serviceTypePlaceholder: "Sélectionnez un service",
        serviceTypes: {
          rental: "Location",
          management: "Gestion locative",
          information: "Information"
        },
        propertyType: "Type de bien",
        propertyTypePlaceholder: "Sélectionnez un type",
        propertyTypes: {
          apartment: "Appartement",
          house: "Maison",
          building: "Immeuble",
          commercial: "Local commercial"
        },
        message: "Message",
        messagePlaceholder: "Décrivez votre projet ou vos besoins...",
        submit: "Envoyer le message",
        submitting: "Envoi en cours...",
        success: "Votre message a été envoyé avec succès. Nous vous recontacterons dans les plus brefs délais.",
        error: "Une erreur est survenue. Veuillez réessayer."
      }
    },
    // Footer
    footer: {
      description: "Votre partenaire de confiance pour la gestion immobilière au Québec. Spécialisé en gestion locative au Québec, nous transformons la gestion locative en une expérience sans stress.",
      tagline: "Spécialisé en gestion locative au Québec",
      creditPrefix: "Site Web conçu par",
      creditLabel: "MTL Programming",
      servicesTitle: "Services",
      servicesList: ["Mise en location", "Gestion locataires", "Encaissement loyers", "Maintenance", "Réparations"],
      contactTitle: "Contact",
      areasTitle: "Zones desservies",
      cities: ["Montréal", "Laval", "Longueuil", "Brossard", "Trois-Rivières"],
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      manageCookies: "Gérer les témoins",
      copyright: "© 2024 Kara Immobilier Service. Tous droits réservés."
    },
    // Chatbot
    chatbot: {
      title: "Assistant Kara Immobilier",
      subtitle: "Toujours disponible pour vous",
      welcome: "Vous êtes propriétaire ? Confiez-nous la gestion de votre bien dès aujourd'hui.",
      placeholder: "Écrivez votre message...",
      error: "Désolé, une erreur s'est produite. Veuillez réessayer."
    },
    // Cookies
    cookies: {
      copy: "Nous utilisons des témoins essentiels pour faire fonctionner le site et mémoriser vos préférences. En cliquant sur « Accepter », vous consentez à leur utilisation.",
      essentialOnly: "Essentiels seulement",
      accept: "Accepter",
      manageCookies: "Gérer les témoins"
    },
    // Legal pages
    legal: {
      privacy: {
        title: "Politique de Confidentialité",
        subtitle: "Kara Immobilier Service",
        lastUpdated: "Dernière mise à jour : 19 mai 2026",
        sections: [
          {
            heading: "Informations que nous collectons et moyens techniques",
            paragraphs: [
              "Nous collectons des informations personnelles que vous nous fournissez directement ou qui sont collectées automatiquement par des moyens technologiques :",
              "Soumissions directes : Nom, adresse e-mail, numéro de téléphone, détails de l'entreprise et données de transaction financière fournies lors de l'intégration du contrat, de la soumission du formulaire de contact ou du paiement par Stripe.",
              "Suivi automatisé : Métadonnées techniques limitées incluant les adresses de protocole Internet, les types de navigateur, les identifiants d'appareil et les enregistrements d'activité des pages via les cookies. Ces données sont collectées automatiquement pour évaluer les performances du système et optimiser l'accessibilité du site."
            ]
          },
          {
            heading: "Comment nous utilisons vos informations",
            paragraphs: [
              "Vos données sont utilisées strictement pour fournir des services de gestion immobilière professionnelle, y compris :",
              "Traitement des paiements, gestion des abonnements et génération de factures via Stripe. Réponse aux demandes de support technique et aux demandes d'architecture de projet. Défense contre les incidents de sécurité, les spams de formulaire non autorisés et les interventions système malveillantes.",
              "Nous ne vendons jamais, ne louons pas et ne commercialisons pas vos informations personnelles avec des tiers à des fins de marketing."
            ]
          },
          {
            heading: "Stockage des données, accès et transferts transfrontaliers",
            paragraphs: [
              "Pour maintenir une fiabilité de qualité professionnelle, vos informations sont traitées à l'aide d'une infrastructure cloud spécialisée :",
              "Limites d'accès interne : L'accès à vos données personnelles est strictement limité au personnel autorisé de Kara Immobilier Service qui doit les informations pour effectuer le déploiement de projets ou la maintenance du système.",
              "Transferts transfrontaliers : Vos données sont stockées sur des serveurs Google Cloud sécurisés et traitées via des voies de paiement comme Stripe. Comme ces centres de données et passerelles de paiement peuvent fonctionner mondialement, vos informations personnelles peuvent être transférées et stockées en dehors de la province du Québec."
            ]
          },
          {
            heading: "Cookies et gouvernance du consentement",
            paragraphs: [
              "Nous utilisons des cookies pour suivre les tendances du trafic et préserver l'intégrité de la session utilisateur. Notre site web utilise des configurations respectueuses de la confidentialité par défaut. Les technologies de suivi non essentielles sont désactivées jusqu'à ce que vous fournissiez un consentement explicite et volontaire via notre banneau de consentement aux cookies. Vous pouvez modifier vos préférences de suivi à tout moment en utilisant les contrôles de cookies situés dans le pied de page de notre site web."
            ]
          },
          {
            heading: "Vos droits et responsabilité",
            paragraphs: [
              "En vertu des lois canadiennes et québécoises sur la protection de la vie privée, vous conservez le droit d'accéder, de rectifier ou de demander la suppression de vos données personnelles. Vous pouvez également retirer votre consentement au traitement des données à tout moment.",
              "L'individu responsable de la gouvernance des renseignements personnels et de la conformité du système chez Kara Immobilier Service est notre agent de protection des données désigné. Pour toute vérification de données, correction ou demande de confidentialité, nous contacter directement à : infokaraimmo@gmail.com."
            ]
          }
        ],
        responsible: "Responsable des renseignements personnels",
        responsibleEntity: "Kara Immobilier Service"
      },
      terms: {
        title: "Conditions d'Utilisation",
        subtitle: "Kara Immobilier Service",
        lastUpdate: "Dernière mise à jour : 18 mars 2026",
        sections: [
          {
            title: "1. Acceptation des conditions",
            content: "En accédant à ce site, vous acceptez les présentes conditions d'utilisation."
          },
          {
            title: "2. Services proposés",
            content: "Kara Immobilier Service offre des services de gestion immobilière, location et accompagnement des propriétaires et locataires."
          },
          {
            title: "3. Utilisation du site",
            content: "Vous vous engagez à utiliser ce site de manière légale et respectueuse."
          },
          {
            title: "4. Propriété intellectuelle",
            content: "Tout le contenu du site est la propriété de Kara Immobilier Service et ne peut être reproduit sans autorisation."
          },
          {
            title: "5. Responsabilité",
            content: "Nous ne garantissons pas l'exactitude complète des informations et ne sommes pas responsables des dommages liés à l'utilisation du site."
          },
          {
            title: "6. Liens externes",
            content: "Le site peut contenir des liens vers des sites tiers dont nous ne sommes pas responsables."
          },
          {
            title: "7. Protection des données",
            content: "Vos données sont traitées conformément à notre politique de confidentialité."
          },
          {
            title: "8. Modifications",
            content: "Nous pouvons modifier ces conditions à tout moment."
          },
          {
            title: "9. Contact",
            content: "Email : infokaraimmo@gmail.com\nTéléphone : 438-439-9590"
          }
        ]
      }
    }
  },
  en: {
    // Navbar
    nav: {
      services: "Services",
      benefits: "Why Choose Us",
      about: "About",
      pricing: "Pricing",
      contact: "Contact",
      cta: "Talk to an Expert",
      ctaSecondary: "Entrust My Property"
    },
    // Hero
    hero: {
      subtitle: "Property Management & Rentals",
      title: "Worry-Free",
      titleAccent: "Property Management.",
      description: "Kara Immobilier Service transforms property management. More revenue, less stress, total transparency.",
      tagline: "More revenue. Less stress.",
      ctaPrimary: "Talk to an Expert",
      ctaSecondary: "Entrust My Property",
      ctaTertiary: "View our Services",
      promises: [
        "Professional service",
        "Fast response",
        "Complete management"
      ]
    },
    // Services
    services: {
      subtitle: "Our Services",
      title: "Complete 360° Management",
      description: "Entrust us with the management of your properties and enjoy total peace of mind.",
      items: [
        {
          title: "Property Listing",
          description: "Professional photos, ad writing, visit organization, credit check and complete tenant verification."
        },
        {
          title: "Complete Tenant Management",
          description: "Calls, follow-ups, complaints - we handle all interactions with your tenants for you."
        },
        {
          title: "Rent Collection",
          description: "Timely and secure rent collection with real-time tracking of your income."
        },
        {
          title: "Late Payment Management",
          description: "Professional follow-ups and unpaid rent management to protect your income."
        },
        {
          title: "Repair Coordination",
          description: "Network of qualified contractors and complete coordination of emergency and maintenance work."
        },
        {
          title: "Maintenance & Upkeep",
          description: "Preventive maintenance programs to preserve the value of your properties."
        },
        {
          title: "Ongoing Follow-up & Support",
          description: "Direct line with your tenants and regular reports on the condition of your properties."
        }
      ]
    },
    // Benefits
    benefits: {
      subtitle: "Results",
      title: "Total Peace of Mind",
      speech: "At Kara Immobilier Service, our goal is to simplify property management while helping owners earn more money. We offer a complete service: finding tenants, managing rent, and ensuring property maintenance. We emphasize reliability, availability, and professionalism. Our priority is to provide a simple and secure experience for our clients.",
      items: [
        {
          title: "You save time",
          description: "No more managing calls, visits or emergencies. We take care of everything."
        },
        {
          title: "You avoid problems",
          description: "Our expertise protects you from difficult tenants and complex situations."
        },
        {
          title: "Your income is secured",
          description: "Guaranteed collection, unpaid rent management and optimization of your profitability."
        }
      ],
      satisfaction: "Satisfaction guaranteed"
    },
    // About - Yakhara Hane
    about: {
      subtitle: "Founder",
      title: "Yakhara Hane",
      role: "Property Manager & Founder of Kara Immobilier Service",
      badge: "Professional Profile",
      paragraphs: [
        "Holding a Bachelor's degree in Business Administration, Yakhara Hane is a determined professional, passionate about property management and the optimization of rental investments.",
        "With a rigorous, human and results-oriented approach, she supports owners in maximizing the value of their assets, offering comprehensive services ranging from rentals to day-to-day building management.",
        "Her goal is simple: to deliver efficient, transparent and profitable management while guaranteeing complete peace of mind for her clients.",
        "Thanks to her attention to detail, her professionalism and her entrepreneurial vision, Yakhara Hane positions Kara Immobilier Service as a trusted partner in the real estate sector."
      ],
      values: [
        { label: "Education", value: "B.B.A — Business Administration" },
        { label: "Approach", value: "Rigorous, human, results-driven" },
        { label: "Vision", value: "Efficient, transparent and profitable management" }
      ]
    },
    // Pricing
    pricing: {
      subtitle: "Our pricing",
      title: "Pricing – Kara Immobilier Service",
      description: "Fair fees aligned with your results — no hidden costs.",
      plans: [
        {
          icon: "listing",
          name: "Property Listing",
          intro: "We support you in finding qualified tenants with a full-service approach including:",
          features: [
            "Professional photography",
            "Ad distribution",
            "Visit organization",
            "Credit check",
            "Employment & reference verification"
          ],
          priceLabel: "Fees:",
          priceLines: [
            "100% of the first month's rent",
            "80% of the first month's rent when combined with a property management mandate"
          ]
        },
        {
          icon: "management",
          name: "Property Management",
          intro: "We ensure complete management of your property to offer you peace of mind and efficiency:",
          features: [
            "Tenant management",
            "Rent monitoring",
            "Complaint handling",
            "Coordination of interventions",
            "Administrative follow-up"
          ],
          priceLabel: "Fees:",
          priceLines: [
            "From 7% of the monthly rent per unit"
          ],
          featured: true
        },
        {
          icon: "maintenance",
          name: "Maintenance & Additional Services",
          intro: "Technical and maintenance services are billed separately:",
          features: [
            "Repairs and work at owner's expense",
            "Cleaning services on demand",
            "Intervention coordination available (applicable fees)"
          ],
          priceLabel: "",
          priceLines: []
        },
        {
          icon: "info",
          name: "Additional Information",
          intro: "Pricing adjustable based on:",
          features: [
            "Building type",
            "Number of units",
            "Specific requirements"
          ],
          priceLabel: "",
          priceLines: []
        }
      ],
      cta: "Get a personalized quote"
    },
    // Contact
    contact: {
      subtitle: "Contact",
      title: "Let's Talk About Your Project",
      description: "Fill out the form and one of our experts will contact you within 24 hours to discuss your needs.",
      responseBadge: "Response within 24h",
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressValue: "9008 2e Avenue, Montréal",
      areas: "Service Areas",
      form: {
        name: "Full name",
        namePlaceholder: "John Smith",
        email: "Email",
        emailPlaceholder: "john@example.com",
        phone: "Phone",
        phonePlaceholder: "+1 438 123 4567",
        serviceType: "Service type",
        serviceTypePlaceholder: "Select a service",
        serviceTypes: {
          rental: "Rental",
          management: "Property management",
          information: "Information"
        },
        propertyType: "Property type",
        propertyTypePlaceholder: "Select a type",
        propertyTypes: {
          apartment: "Apartment",
          house: "House",
          building: "Building",
          commercial: "Commercial space"
        },
        message: "Message",
        messagePlaceholder: "Describe your project or needs...",
        submit: "Send message",
        submitting: "Sending...",
        success: "Your message has been sent successfully. We will contact you as soon as possible.",
        error: "An error occurred. Please try again."
      }
    },
    // Footer
    footer: {
      description: "Your trusted partner for property management in Quebec. Specialized in rental management in Quebec, we transform rental management into a stress-free experience.",
      tagline: "Specialized in rental management in Quebec",
      creditPrefix: "Custom website by",
      creditLabel: "MTL Programming",
      servicesTitle: "Services",
      servicesList: ["Property listing", "Tenant management", "Rent collection", "Maintenance", "Repairs"],
      contactTitle: "Contact",
      areasTitle: "Service areas",
      cities: ["Montréal", "Laval", "Longueuil", "Brossard", "Trois-Rivières"],
      legal: "Legal notice",
      privacy: "Privacy policy",
      terms: "Terms of use",
      manageCookies: "Manage cookies",
      copyright: "© 2024 Kara Immobilier Service. All rights reserved."
    },
    // Chatbot
    chatbot: {
      title: "Kara Immobilier Assistant",
      subtitle: "Always available for you",
      welcome: "Are you a property owner? Entrust us with the management of your property today.",
      placeholder: "Write your message...",
      error: "Sorry, an error occurred. Please try again."
    },
    // Cookies
    cookies: {
      copy: "We use essential cookies to operate the site and remember your preferences. By clicking \"Accept\", you consent to their use.",
      essentialOnly: "Essential only",
      accept: "Accept",
      manageCookies: "Manage cookies"
    },
    // Legal pages
    legal: {
      privacy: {
        title: "Privacy Policy",
        subtitle: "Kara Immobilier Service",
        lastUpdated: "Last updated: May 19, 2026",
        sections: [
          {
            heading: "Information We Collect and Technical Means",
            paragraphs: [
              "We collect personal information that you provide directly to us or that is gathered automatically through technological means:",
              "Direct Submissions: Name, email address, phone number, corporate details, and financial transaction data provided during contract onboarding, contact form submissions, or Stripe checkout.",
              "Automated Tracking: Limited technical metadata including internet protocol addresses, browser types, device identifiers, and page activity records via cookies. This data is collected automatically to evaluate system performance and optimize site accessibility."
            ]
          },
          {
            heading: "How We Use Your Information",
            paragraphs: [
              "Your data is utilized strictly to deliver professional web engineering and managed services, including:",
              "Processing payments, managing subscriptions, and generating invoices via Stripe. Responding to technical support tickets and project architecture requests. Defending against security incidents, unauthorized form spam, and malicious system interventions.",
              "We never sell, rent, or trade your personal information with third parties for marketing purposes."
            ]
          },
          {
            heading: "Data Storage, Access, and Cross Border Transfers",
            paragraphs: [
              "To maintain enterprise grade reliability, your information is processed using specialized cloud infrastructure:",
              "Internal Access Limits: Access to your personal data is strictly limited to authorized personnel within MTL Programming who require the information to perform project deployment or system maintenance.",
              "Cross Border Transfers: Your data is stored on secure Google Cloud servers and processed through payment pathways like Stripe. Because these data centers and payment gateways may operate globally, your personal information may be transferred and stored outside the Province of Quebec."
            ]
          },
          {
            heading: "Cookies and Consent Governance",
            paragraphs: [
              "We employ cookies to track traffic patterns and preserve user session integrity. Our website uses privacy by default configurations. Non essential tracking technologies are deactivated until you provide explicit, voluntary consent through our cookie consent banner. You can modify your tracking preferences at any time using the cookie controls located in our website footer."
            ]
          },
          {
            heading: "Your Rights and Accountability",
            paragraphs: [
              "Under Canadian and Quebec privacy regulations, you retain the right to access, rectify, or request the deletion of your personal data. You may also withdraw your consent to data processing at any time.",
              "The individual accountable for personal information governance and system compliance at MTL Programming is our designated Privacy Officer. For any data verification, correction, or privacy inquiries, contact us directly at: info@mtlprogramming.com."
            ]
          }
        ],
        responsible: "Personal Information Officer",
        responsibleEntity: "Kara Immobilier Service"
      },
      terms: {
        title: "Terms of Use",
        subtitle: "Kara Immobilier Service",
        lastUpdate: "Last updated: March 18, 2026",
        sections: [
          {
            title: "1. Acceptance of Terms",
            content: "By accessing this site, you accept these terms of use."
          },
          {
            title: "2. Services Offered",
            content: "Kara Immobilier Service offers property management, rental and support services for owners and tenants."
          },
          {
            title: "3. Site Usage",
            content: "You agree to use this site in a legal and respectful manner."
          },
          {
            title: "4. Intellectual Property",
            content: "All site content is the property of Kara Immobilier Service and cannot be reproduced without authorization."
          },
          {
            title: "5. Liability",
            content: "We do not guarantee complete accuracy of information and are not responsible for damages related to site use."
          },
          {
            title: "6. External Links",
            content: "The site may contain links to third-party sites for which we are not responsible."
          },
          {
            title: "7. Data Protection",
            content: "Your data is processed in accordance with our privacy policy."
          },
          {
            title: "8. Modifications",
            content: "We may modify these conditions at any time."
          },
          {
            title: "9. Contact",
            content: "Email: infokaraimmo@gmail.com\nPhone: 438-439-9590"
          }
        ]
      }
    }
  }
};

export type Language = "fr" | "en";
export type Translation = (typeof translations)[Language];

export default translations;
